export { default as PromoInput } from './PromoInput/PromoInput';
